import * as TYPES from './action-types';
export default {
	namespaced: true,
	state: {
		aim: '',
		orderInfo: null
	},
	getters: {
		aim: state => state.aim,
		orderInfo: state => state.orderInfo
	},
	mutations: {
		[TYPES.ORDER__SET_AIM](state, payload) {
			state.aim = payload;
		},
		[TYPES.ORDER__SET_ORDER_INFO](state, payload) {
			state.orderInfo = payload;
		}
	},
	actions: {
		[TYPES.ORDER__SET_AIM]({commit}, payload) {
			commit(TYPES.ORDER__SET_AIM, payload);
		},
		[TYPES.ORDER__SET_ORDER_INFO]({commit}, payload) {
			commit(TYPES.ORDER__SET_ORDER_INFO, payload);
		}
	}
}
